import { FormAdapterBase } from '../form-adapter-base';
import { FormGroup, Validators } from '@angular/forms';
import { EmploymentHistoryFormGroup } from '../../interfaces/employment-history';

export class EmploymentHistoryValidatorAdapter
  <T extends FormGroup> extends FormAdapterBase<T, EmploymentHistoryFormGroup> {

    private applied = false;

    public apply(): void {
        this.setupDefaultValidators();
    }

    private setupDefaultValidators(): void {
        if (this.applied)  {
            return;
        }

        const historyForm = this.getTargetForm();
        historyForm.get('name')!.setValidators([Validators.required]);
        historyForm.get('position')!.setValidators([Validators.required]);
        historyForm.get('startDate')!.setValidators([Validators.required]);
        historyForm.get('endDate')!.setValidators([Validators.required]);
        historyForm.get('isCurrent')!.setValidators([Validators.required]);

        historyForm.updateValueAndValidity();
        this.applied = true;
    }
}
